import React, { useRef, useEffect } from 'react'
import Carousel from 'react-multi-carousel'

import { Button } from '@/components/Button'
import Icons from '@/components/Icons'

import { ButtonWrapperLeft, ButtonWrapperRight, Box, StyledDotBar } from './ProductViewSliderStyles'

const BREAKPOINTS = {
  all: {
    breakpoint: { max: 3000, min: 0 },
    items: 1,
  },
}
export interface SliderProps {
  sliderContent?: {
    id: string
    url: string
    alt?: string
  }[]
  position?: number
  clickedImageIndex?: any
}

export interface StylesProps {
  color?: string
  activeSlide?: boolean
}

type CustomDotProps = { active?: boolean; onClick?: any }
const CustomDot: React.VFC<CustomDotProps> = ({ active, onClick }) => <StyledDotBar active={active} onClick={onClick} />

type ButtonGroupProps = { next?: () => any; previous?: () => any }
const ButtonGroup: React.VFC<ButtonGroupProps> = ({ next, previous }) => {
  return (
    <>
      <ButtonWrapperLeft onClick={() => previous()}>
        <Button variant="verticalRad" colorVariant="primary" borderNone>
          <Icons.ChevronLeft />
        </Button>
      </ButtonWrapperLeft>
      <ButtonWrapperRight onClick={() => next()}>
        <Button variant="verticalRad" colorVariant="primary" borderNone>
          <Icons.ChevronRight />
        </Button>
      </ButtonWrapperRight>
    </>
  )
}

export const Slider: React.VFC<SliderProps> = ({ sliderContent, clickedImageIndex }) => {
  const carouselRef = useRef<Carousel>()

  useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.goToSlide(clickedImageIndex + 1)
    }
  }, [clickedImageIndex])

  return (
    <Carousel
      ref={carouselRef}
      responsive={BREAKPOINTS}
      swipeable
      infinite
      keyBoardControl
      minimumTouchDrag={80}
      showDots
      slidesToSlide={1}
      arrows={false}
      customDot={<CustomDot />}
      customButtonGroup={<ButtonGroup />}
    >
      {sliderContent.map((image) => (
        <Box key={image.id}>
          <img style={{ userSelect: 'none' }} draggable={false} src={image.url} alt={image.alt || ''} />
        </Box>
      ))}
    </Carousel>
  )
}
